/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 1 = Retail
 *
 * 2 = Internal
 *
 * 3 = Warranty
 *
 * 4 = Fleet
 */
export enum WarrantyJobTypeEnum {
  Retail = 1,
  Internal = 2,
  Warranty = 3,
  Fleet = 4,
}
